"use client";
import { useIsMobile } from "@/app/Hooks/useIsMobile";
import { MobileAdUnit, SidebarAd } from "../AdsBox/AdsBox";
import SmallImagesNewsCard from "../Helper/SmallImagesNewsCard";
import Title from "../Helper/Title";
import Breadcrumb from "../Posts/PostDetails/Breadcrumb";
import CategoryList from "./CategoryList";
import dynamic from "next/dynamic";
const Pagination = dynamic(() => import("antd/es/pagination"), {
  ssr: false,
});
import { useRouter } from "next/navigation";

const Category = ({
  tagSlug,
  tagsData,
  currentPage,
  meta,
  viralNews,
  tagsDetails,
}) => {
  const isMobile = useIsMobile();
  const router = useRouter();

  const handlePageChange = (page, categorySlug) => {
    router.push(`/tag/${categorySlug}/page/${page}`);
  };

  const breadcrumbs = [
    ...(tagsDetails?.breadcrumbs || []),
    ...(currentPage > 1
      ? [
          {
            label: `Page ${currentPage}`,
            url: "",
          },
        ]
      : []),
  ];

  const design = (
    <>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <div className="max-w-3xl bg-white mt-6">
        <h1 className="text-[22px] font-extrabold text-black leading-[22px] -mt-3">
          {tagsDetails?.title}
          {currentPage > 1 ? ` - Page ${currentPage}` : null}
        </h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 border-t pt-6 mt-6">
        {/* LEFT - unchanged core UI */}
        <div className="lg:col-span-8">
          <CategoryList tagsData={tagsData} />
          <div className="flex justify-center lg:justify-start py-5 ">
            <Pagination
              onChange={(e) => handlePageChange(e, tagSlug)}
              defaultCurrent={currentPage}
              total={meta?.total}
              pageSize={meta?.pageSize}
            />
          </div>
        </div>

        {/* RIGHT - new design */}
        <div className="lg:col-span-4">
          {/* <RightSidebar /> */}

          <aside className="order-3 lg:order-3 lg:col-span-3  ">
            {isMobile ? <MobileAdUnit /> : <SidebarAd />}
            {/* related news */}
            <div className="mb-5 mt-4">
              <Title size="18px">वायरल खबरें</Title>
            </div>

            <div className="space-y-5">
              {viralNews?.map((item, index) => (
                <div key={index} className="border-b pb-3">
                  <SmallImagesNewsCard
                    title="खेल"
                    subtitle={item?.title}
                    image={item?.thumbnail}
                    showDot
                    showMainTitle
                    fontWeight="800"
                    isVideo={item?.is_video}
                    href={item.permalink}
                    subtitleProps={{
                      size: "15px",
                      lineHeight: "20px",
                      className: "cursor-pointer",
                    }}
                  />
                </div>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </>
  );
  return design;
};

export default Category;
